<template>
  <div id="detail_packaging" class="w-full h-full px-5 pt-6">
    <div id="top_bar" class="h-1/10 items-start">
      <div id="back"
           class="text-left col-span-1  col-start-1 row-start-1 1.5xl:col-span-1 1.5xl:col-start-1">
        <button
          class="title classen__rounded_full hover__button bg-white w-full md:w-1/3 lg:w-2/3 border-classen__primary border-2 text-left"
          @click="$emit('close')"><i class="fas fa-angle-left"></i>
          {{ getTranslation('backToPackagings') }}
        </button>
      </div>
      <div class="col-start-3 flex justify-center">
          <!-- TODO: re-enable -->
        <button v-if="false" class="classen__button copy_button relative" @click="copyUrl">
          <p class="leading-none m-0 label absolute" v-if="isCopied"><img class="ml-2"
                                                                          src="../../../assets/icons/checkmark.svg"
                                                                          alt="checkmark"> URL
            copied </p>
          <img src="../../../assets/icons/copy_blue.svg">
        </button>
        <button @click="getArticleExport"
                class="actionButton classen__button hover__button classen__button_active cursor-pointer ml-2">
          <p class="leading-none">{{ getTranslation('exportArticleList') }}</p>
        </button>
      </div>
    </div>

    <div id="packaging_form" class="h-9/10 w-full lg:w-2/3 mt-5 lg mx-auto">
      <c-packaging-form class="col-start-2" :packaging="packaging"/>
    </div>
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import download from "../../../mixins/download";
import Button from "../../Button";
import PackagingDetailForm from "./PackagingDetailForm";

export default {
  name: "PackagingDetail",

  components: {
    Button,
    'c-packaging-form': PackagingDetailForm,
  },

  mixins: [getTranslation, download],

  props: {
    packaging: {required: true}
  },

  data() {
    return {
      isLoaded: true,
      currentTab: 0,
      packagingAssets: [],
      isCopied: false,
    }
  },

  methods: {
    getArticleExport() {
      this.isLoaded = false;
      this.$dashboardStore.dispatch('getPackagesArticleExport', this.packaging.id)
        .then((res) => {
          this.downloadFile(res.url)
          this.isLoaded = false;
        })
    },

    copyUrl() {
      const basePath = window.location.host;
      const protocol = window.location.protocol;
      const url = `${protocol}//${basePath}/#/package/${this.packaging.id}`;
      navigator.clipboard.writeText(url);
      this.isCopied = true;
    }
  }
}
</script>

<style scoped>
#tabs > label {
  height: 25px;
  width: fit-content;
}

#top_bar, #product_form {
  display: grid;
  grid-template-columns: 18% 50% 32%;
}

.downloadAll {
  height: 40px;
  line-height: 40px;
}

#back {
  width: 320px !important
}

.copy_button {
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  /*position: absolute;*/
  /*right: 0;*/
}

.copy_button > img {
  width: 22px;
  height: 22px;
}

.label {
  display: flex;
  height: 42px;
  line-height: 42px;
  left: -115px;
  width: 110px;
  @apply mr-2 text-classen__primary;
}

.label > img {
  height: 20px;
  margin-top: 11px;
}
</style>
